const footer = document.querySelector('footer');

if (footer) {
  const wave = document.createElement('div');
  wave.className = 'wave';
  footer.prepend(wave);   // inserts as the first element inside <footer>
}